import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import messages from './messages'
import { useMutateUnarchiveCreditCardItem } from '../../models'

// Split from archive per the activate/deactivate-split rule. No confirmation
// dialog — unarchiving is an immediate, reversible action (BHV-020).
export const useUnarchiveCreditCardItemPresenter = () => {
  const intl = useProcurifyIntl()
  const { unarchive, isLoading } = useMutateUnarchiveCreditCardItem()

  const unarchiveCreditCardItem = async (item: CreditCardItem) => {
    try {
      await unarchive({ id: item.id })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage, {
          description: item.description,
        }),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    commands: {
      unarchive: unarchiveCreditCardItem,
    },
    states: {
      isUnarchiving: isLoading,
    },
  }
}
